import { NgModule } from '@angular/core';
import { RouterModule }   from '@angular/router';
// import { LayoutsHeadComponent } from './head/head.component';
import { LayoutsHeaderComponent } from './header/header.component';
import { LayoutsFooterComponent } from './footer/footer.component';
import { MaterialModule } from '../components/material.module';

@NgModule({
    imports: [RouterModule, MaterialModule],
    declarations: [ LayoutsHeaderComponent, LayoutsFooterComponent],
    providers: [],
    exports: [ LayoutsHeaderComponent, LayoutsFooterComponent]
})
export class LayoutsModule {}



// WEBPACK FOOTER //
// ./src/app/layouts/layouts.module.ts